/* src/app/shared/components/loader/loader.component.scss */
.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 100;
}
.loaderMiniContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 130px;
  height: fit-content;
}
.barContainer {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
  background-position: left;
}
.bar {
  width: 100%;
  height: 8px;
  background:
    linear-gradient(
      to right,
      var(--primary-500),
      var(--primary-200),
      var(--primary-500));
  background-size: 200% 100%;
  border-radius: 10px;
  animation: bar ease-in-out 3s infinite alternate-reverse;
}
@keyframes bar {
  0% {
    background-position: left;
  }
  100% {
    background-position: right;
  }
}
.bar2 {
  width: 50%;
}
.svgIcon {
  position: absolute;
  left: -25px;
  margin-top: 18px;
  z-index: 2;
  width: 70%;
}
.animate-continue {
  animation: search ease-in-out 2s infinite alternate-reverse;
}
.animate-forward {
  position: static;
  animation: zoom ease-in-out 0.7s forwards;
}
@keyframes zoom {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(70);
    display: none;
  }
}
@keyframes search {
  0% {
    transform: translateX(0%) rotate(70deg);
  }
  100% {
    transform: translateX(100px) rotate(10deg);
  }
}
.svgIcon circle,
line {
  stroke: var(--primary-500);
}
.svgIcon circle {
  fill: var(--primary-100);
  fill-opacity: 0.5;
}
/*# sourceMappingURL=loader.component.css.map */
